export class ArticleTypeConstants {
  public static readonly TYPE_UNKNOWN: string = 'Unknown';
  public static readonly TYPE_BLOCKING_ZONE: string = 'Platzsperre';
  public static readonly TYPE_EMPTY_ZONE: string = 'Leerraum';
  public static readonly TYPE_CUSTOM_ARTICLE: string = 'Fremdartikel';
  public static readonly TYPE_BRIDGE: string = 'Brücker';
  public static readonly TYPE_WIRE_BRIDGE: string = 'Drahtbrücker';
  public static readonly TYPE_DRILLING_HOLE: string = 'Bohrlöcher';
  public static readonly TYPE_LABELING: string = 'Beschriftungsmaterial';
  public static readonly TYPE_MOUNTING_RAIL: string = 'Tragschiene';
  public static readonly TYPE_END_PLATE: string = 'Abschlussplatte';
  public static readonly TYPE_END_STOP: string = 'Endklammer';
  public static readonly TYPE_CODING_KEY: string = 'Kodierung';
  public static readonly TYPE_CONNECTORS: string = 'Stiftleisten';
  public static readonly TYPE_ELECTRONIC_ATTACHMENT: string = 'Electronic Aufsteckteil';
  public static readonly TYPE_FOREIGN_PLUG: string = 'Winsta Foreign Plug';
  public static readonly TYPE_GENERAL_ACCESSORY: string = 'allgemeines Zubehör';
  public static readonly TYPE_INSTALLATION_TECHNOLOGY: string = 'Installationstechnik';
  public static readonly TYPE_INSULATION_STOP: string = 'Isolierungs-Stopp';
  public static readonly TYPE_LOCKING: string = 'Verriegelung';
  public static readonly TYPE_MARKER_CARRIER: string = 'Beschriftungsträger';
  public static readonly TYPE_N_BUSBAR: string = 'N-Sammelschiene';
  public static readonly TYPE_COVER: string = 'Abdeckungsprofil';
  public static readonly TYPE_PROTECTIVE_WARNING_MARKER: string = 'Warnabdeckung';
  public static readonly TYPE_STRAIN_RELIEF: string = 'Zugentlastung';
  public static readonly TYPE_WIRE_FERRULE: string = 'Aderendhülsen';
  public static readonly TYPE_RAIL_ACCESSORY: string = 'TS-Zubehör';

  public static readonly TYPE_MULTI_CONNECTORS: string = 'Multistecker';
  public static readonly TYPE_MALE_HEADER_FOR_PCB: string = 'Stiftleisten';

  public static readonly TYPE_TERMINAL_BLOCK: string = 'Reihenklemme';

  public static readonly TYPE_CODING_FINGER: string = 'Kodiernase';
  public static readonly TYPE_CONTACT: string = 'Kontakt';
  public static readonly TYPE_MCS_GDS_END_PLATE: string = 'Abschlussplatte für MCS/GDS Projekte';

  public static readonly BASE_ARTICLE_TYPES: string[] = [ArticleTypeConstants.TYPE_MOUNTING_RAIL];
  public static readonly EXCLUDED_TYPES_FROM_COMPOSITE_ARTICLE: string[] = [ArticleTypeConstants.TYPE_MOUNTING_RAIL,
    ArticleTypeConstants.TYPE_DRILLING_HOLE];
  public static readonly EXCLUDED_ARTICLE_TYPES: string[] = [ArticleTypeConstants.TYPE_END_PLATE,
    ArticleTypeConstants.TYPE_MCS_GDS_END_PLATE];
}
